var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room",
      attrs: {
        "data-grm-comp": "RoomCamStudy",
        "data-roomid": _vm.room.roomId,
        "data-groupid": _vm.room.groupId,
        "data-roomType": _vm.room.roomType,
        "data-open-extend-menu": _vm.isOpenExtendMenu,
      },
    },
    [
      _vm.readyToEnter && !_vm.isLeaved
        ? [
            _c("div", { staticClass: "room-container" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "min-height": "0",
                    display: "flex",
                    "flex-direction": "column",
                  },
                },
                [
                  _c("CamstudyRoomInfo", {
                    class: { visible: _vm.isOpenControlMenu || !_vm.isMobile },
                    attrs: { roomInfo: _vm.room },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "room-main",
                      on: { click: _vm.onToggleControlMenu },
                    },
                    [
                      _c(
                        "transition-group",
                        { attrs: { name: "fade" } },
                        [
                          !_vm.isRoomMode("media")
                            ? _c(_vm.roomMainComponent, {
                                key: "room-main",
                                tag: "component",
                                staticClass: "room-main-component",
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.showConnectionStats === true
                        ? _c("RoomCallConnectionState", {
                            staticStyle: {
                              position: "absolute",
                              "z-index": "10",
                              top: "0px",
                              left: "0",
                              "pointer-events": "none",
                            },
                          })
                        : _vm._e(),
                      _vm.showRoomConnectionStateLoading
                        ? _c("Loading", {
                            attrs: {
                              msg: _vm.$t(
                                "room.connectionState.msg." +
                                  _vm.connectionState
                              ),
                            },
                          })
                        : _vm._e(),
                      _c("GrmSnackbarList", {
                        attrs: { isOpenExtendMenu: _vm.isOpenExtendMenu },
                      }),
                    ],
                    1
                  ),
                  _c("CamstudyWhiteNoiseAudio"),
                  _c("CamstudyControl", {
                    class: { visible: _vm.isOpenControlMenu || !_vm.isMobile },
                    attrs: {
                      v2CamsHomeUrl: _vm.v2CamsHomeUrl,
                      isOpenControlMenu: _vm.isOpenControlMenu,
                      roomInfo: _vm.room,
                    },
                  }),
                  _c(
                    "RoomWindowOpen",
                    {
                      ref: "newWindowMenu",
                      attrs: {
                        title: `[Gooroomee-PIP] ${_vm.$t(
                          "setting.chat.title"
                        )}`,
                        width: 320,
                        minWidth: 320,
                        height: 800,
                        minHeight: 800,
                      },
                    },
                    [
                      _c("RoomExtendMenu", {
                        attrs: {
                          chatHistoryProp: _vm.chatHistory(),
                          newWindow: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm.isOpenPlusModal
              ? _c("PremiumPlusModal", {
                  on: { close: _vm.onClosePremiumPlusModal },
                })
              : _vm._e(),
          ]
        : [
            _vm.isShowSetDevice
              ? _c("CamstudyDeviceSetting", {
                  ref: "waitingRoom",
                  attrs: {
                    roomInfo: _vm.room,
                    deviceSettings: _vm.deviceSettings,
                    isDevicetest: "",
                  },
                  on: { onUpdateReqEnterNickname: _vm.setUserNickname },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }